import { defineComponent as z, onMounted as R, onUnmounted as I, computed as u, ref as B, openBlock as s, createElementBlock as w, normalizeClass as d, createVNode as y, unref as m, withCtx as g, createElementVNode as c, normalizeStyle as F, toDisplayString as k, createBlock as p, createCommentVNode as N, Teleport as X, Fragment as T, renderList as W, renderSlot as M } from "vue";
import $ from "./index60.js";
import { Listbox as U, ListboxButton as Y, ListboxOptions as q, ListboxOption as D } from "./index283.js";
const G = { class: "flex w-full min-w-0 items-center justify-between gap-2" }, H = { class: "truncate" }, J = 4, _ = /* @__PURE__ */ z({
  __name: "BaseInputSelect",
  props: {
    modelValue: { default: void 0 },
    variant: { default: "default" },
    color: { default: "white" },
    placeholder: { default: "선택하세요" },
    size: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    errorMessage: { default: "" },
    options: { default: () => [] },
    noPaddingX: { type: Boolean, default: !1 },
    textAlign: { default: "left" },
    width: { default: "full" },
    teleport: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "focus", "blur", "open"],
  setup(o, { emit: V }) {
    const E = z({
      name: "BaseInputSelectScrollSync",
      props: {
        triggerRef: {
          type: Object,
          required: !0
        }
      },
      emits: ["scroll"],
      setup(l, { emit: r }) {
        const a = [], e = () => r("scroll");
        return R(() => {
          const i = l.triggerRef?.value?.value ?? null;
          if (!i) return;
          let n = i.parentElement;
          for (; n; ) {
            const { overflowX: x, overflowY: P } = getComputedStyle(n);
            (/(auto|scroll|overlay)/.test(x) || /(auto|scroll|overlay)/.test(P)) && a.push(n), n = n.parentElement;
          }
          a.push(window), a.forEach((x) => x.addEventListener("scroll", e, !0));
        }), I(() => {
          a.forEach((i) => i.removeEventListener("scroll", e, !0));
        }), () => null;
      }
    }), t = o, b = V, v = u({
      get() {
        return t.options.find((l) => l.value === t.modelValue) || null;
      },
      set(l) {
        l && b("update:modelValue", l.value);
      }
    }), j = u(() => {
      const l = t.textAlign === "center" ? "justify-center" : t.textAlign === "right" ? "justify-end" : "justify-between", r = t.variant === "compact" || t.variant === "compact-bold" || t.variant === "header" ? `relative w-full min-w-0 transition-all duration-150 flex items-center ${l} tracking-[-0.35px] ` : `relative w-full min-w-0 rounded-md transition-all duration-150 border border-solid flex items-center ${l} tracking-[-0.35px]`, a = t.noPaddingX ? "px-0" : "", e = t.variant === "header" ? `${a || "px-0"} h-auto text-[16px] font-semibold leading-[18px]` : t.variant === "compact-bold" ? `${a || "px-[15px]"} h-[24px] text-[14px] font-semibold leading-[16px]` : t.variant === "compact" ? `${a || "px-[15px]"} h-[24px] text-[10px] font-meidum leading-[16px]` : t.variant === "chart-window" ? `${a || "px-[10px]"} h-[24px] text-[13px] leading-[16px] font-semibold` : t.size === "sm" ? `${a || "px-[15px]"} h-[42px] text-[14px] leading-[16px]` : `${a || "px-[15px]"} h-[48px] text-[16px] leading-[20px]`, i = t.variant === "header" ? "bg-transparent" : t.color === "black" ? "bg-[var(--input-color-surface-dark)] !text-[#F1F3F5] !border-[var(--input-color-border-dark)]" : t.color === "gray" ? "bg-[var(--chart-chart-bg-on)]" : "bg-[var(--input-color-surface)]";
      let n = "";
      t.disabled ? n = (t.variant === "compact" || t.variant === "compact-bold" || t.variant === "chart-window" || t.variant === "header" || t.variant === "default", "cursor-not-allowed") : n = t.variant === "header" ? "" : "border-input-border-static";
      const x = v.value ? "text-input-text-static" : "text-input-text-placeholder";
      return `${r} ${e} ${n} ${x} ${i}`;
    }), A = u(() => t.textAlign === "center" ? "text-center" : t.textAlign === "right" ? "text-right" : "text-left"), S = u(() => t.width === "auto" ? "w-auto" : t.width === "fit" ? "w-fit" : "w-full"), h = B(null), L = u(() => ({ value: h })), f = B({ top: 0, left: 0, width: 0 }), C = () => {
      const l = h.value;
      if (!l) return;
      const r = l.getBoundingClientRect();
      f.value = {
        top: r.bottom + J,
        left: r.left,
        width: r.width
      };
    }, O = u(() => ({
      position: "fixed",
      top: `${f.value.top}px`,
      left: `${f.value.left}px`,
      width: `${f.value.width}px`,
      minWidth: `${f.value.width}px`
    }));
    return (l, r) => (s(), w("div", {
      class: d(S.value)
    }, [
      y(m(U), {
        modelValue: v.value,
        "onUpdate:modelValue": r[2] || (r[2] = (a) => v.value = a),
        disabled: o.disabled
      }, {
        default: g(({ open: a }) => [
          c("div", {
            class: d(["relative", S.value])
          }, [
            c("div", {
              ref_key: "triggerRef",
              ref: h,
              class: "inline-block w-full",
              onPointerdown: C
            }, [
              y(m(Y), {
                class: d(j.value),
                style: F(
                  o.disabled ? o.variant === "default" ? "background-color: var(--input-color-bg-disabled); border-color: var(--input-color-border-disabled); color: var(--input-color-text-disable) !important; opacity: 1;" : "color: var(--input-color-text-disable) !important; opacity: 1;" : ""
                ),
                onFocus: r[0] || (r[0] = (e) => b("focus", e)),
                onBlur: r[1] || (r[1] = (e) => b("blur", e)),
                onClick: (e) => !a && b("open")
              }, {
                default: g(() => [
                  c("span", {
                    class: d(["truncate", A.value])
                  }, k(v.value?.label || o.placeholder), 3),
                  o.variant === "default" ? (s(), p($, {
                    key: 0,
                    name: "arrow-down",
                    size: o.size === "sm" ? "sm" : "md",
                    color: o.disabled ? "disabled" : "default",
                    className: `ml-2 flex-shrink-0 transition-transform duration-200 ${a ? "rotate-180" : ""}`
                  }, null, 8, ["size", "color", "className"])) : o.variant === "header" ? (s(), p($, {
                    key: 1,
                    name: "arrow-down",
                    size: "md",
                    color: o.disabled ? "disabled" : "default",
                    className: `ml-2 flex-shrink-0 transition-transform duration-200 ${a ? "rotate-180" : ""}`,
                    style: { width: "20px", height: "20px" }
                  }, null, 8, ["color", "className"])) : (s(), p($, {
                    key: 2,
                    name: "arrow-down-solid",
                    size: "md",
                    color: o.disabled ? "disabled" : "default-muted-dark",
                    className: `ml-2 flex-shrink-0 transition-transform duration-200 ${a ? "rotate-180" : ""}`
                  }, null, 8, ["color", "className"]))
                ]),
                _: 2
              }, 1032, ["class", "style", "onClick"])
            ], 544),
            a ? (s(), p(m(E), {
              key: 0,
              "trigger-ref": L.value,
              onScroll: C
            }, null, 8, ["trigger-ref"])) : N("", !0),
            (s(), p(X, {
              to: "#overlay-root",
              disabled: !o.teleport
            }, [
              y(m(q), {
                class: d([
                  t.variant === "compact-bold" || t.variant === "compact" ? "z-tooltip max-h-60 overflow-auto bg-[--chart-chart-bg-on] py-1 shadow-lg" : "border-input-border-static z-tooltip max-h-60 overflow-auto rounded-md border py-1 shadow-lg",
                  t.color === "black" ? "!border-[var(--input-color-border-dark)] bg-[var(--input-color-surface-dark)]" : t.color === "gray" ? "bg-[var(--chart-chart-bg-on)]" : "bg-[var(--input-color-surface)]"
                ]),
                style: F(O.value)
              }, {
                default: g(() => [
                  (s(!0), w(T, null, W(o.options, (e) => (s(), p(m(D), {
                    key: e.value,
                    value: e,
                    disabled: e.disabled
                  }, {
                    default: g(({ active: i, selected: n }) => [
                      c("li", {
                        class: d([
                          t.variant === "compact-bold" ? "relative cursor-default select-none py-2 pl-3 pr-3 text-[14px] font-semibold leading-[16px] tracking-[-0.35px]" : t.variant === "compact" ? "relative cursor-default select-none py-2 pl-3 pr-3 text-[10px] font-medium leading-[16px] tracking-[-0.35px]" : "relative cursor-default select-none py-2 pl-3 pr-3 text-[13px] leading-[16px] tracking-[-0.35px]",
                          t.color === "black" ? "!text-[#F1F3F5]" : "",
                          e.disabled ? "text-input-text-disable cursor-not-allowed opacity-50" : i ? t.color === "black" ? "text-input-text-static bg-[#131313]" : "text-input-text-static bg-[var(--background-bg-surface-muted)]" : "text-input-text-static",
                          n && !e.disabled ? "font-medium" : ""
                        ])
                      }, [
                        M(l.$slots, "option", {
                          option: e,
                          active: i,
                          selected: n
                        }, () => [
                          c("span", G, [
                            c("span", H, k(e.label), 1),
                            e.subtext ? (s(), w("span", {
                              key: 0,
                              class: d([
                                "shrink-0",
                                e.disabled ? "text-input-text-disable" : "text-default-muted"
                              ])
                            }, k(e.subtext), 3)) : N("", !0)
                          ])
                        ])
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value", "disabled"]))), 128))
                ]),
                _: 3
              }, 8, ["class", "style"])
            ], 8, ["disabled"]))
          ], 2)
        ]),
        _: 3
      }, 8, ["modelValue", "disabled"])
    ], 2));
  }
});
export {
  _ as default
};
